export default {
  title: 'My Courses',
  searchPH: 'Search by course name',
  sortByName: 'Course name',
  sortByDate: 'Created on'
}



// WEBPACK FOOTER //
// ./src/i18n/mycourses/en.js